import { ActiveTabEnum, SettledTabEnum } from "@tvg/sh-lib-my-bets/utils/types";

export const getTabs = (totalActiveBets: number, totalFutureBets: number) => [
  {
    label: "Active",
    value: ActiveTabEnum.ACTIVE,
    counter: totalActiveBets,
    qaLabel: "bets-active-tab"
  },
  {
    label: "Future",
    value: ActiveTabEnum.FUTURES,
    counter: totalFutureBets,
    hidden: !totalFutureBets,
    qaLabel: "bets-future-tab"
  },
  {
    label: "Settled",
    value: ActiveTabEnum.SETTLED,
    qaLabel: "bets-settled-tab"
  }
];

export const getTimeFramesTabs = () => [
  {
    label: "Today",
    value: SettledTabEnum.TODAY,
    qaLabel: "bets-settled-today-tab"
  },
  {
    label: "Since Yesterday",
    value: SettledTabEnum.YESTERDAY,
    qaLabel: "bets-settled-yesterday-tab"
  },
  {
    label: "Since Last Week",
    value: SettledTabEnum.LAST_WEEK,
    qaLabel: "bets-settled-last-week-tab"
  },
  {
    label: "Since Last Month",
    value: SettledTabEnum.LAST_MONTH,
    qaLabel: "bets-settled-last-month-tab"
  }
];
